<template>
	<div class="home-page">
		<section class="hero" :style="heroBgStyle">
			<div class="hero-inner">
				<p class="hero-tag">DOWA Metaltech</p>
				<h1 class="hero-title">同和金属材料（上海）有限公司</h1>
				<p class="hero-sub">
					依托 DOWA 集团在高性能铜合金领域的技术积累，为中国及亚太客户提供铜合金、钛铜、铜镍硅、黄铜、纯铜等材料解决方案与本地化服务。
				</p>
				<div class="hero-actions">
					<router-link class="btn btn-primary" to="/productclass/1">浏览产品</router-link>
					<a href="#company-intro" class="btn btn-outline" @click.prevent="scrollTo('company-intro')">了解更多</a>
					<router-link class="btn btn-outline" to="/questionnaire">材料咨询</router-link>
				</div>
			</div>
		</section>

		<section id="company-intro" class="section company-intro">
			<div class="container">
				<h2 class="section-title">企业概况</h2>
				<p class="lead">
					同和金属材料（上海）有限公司是 DOWA 集团旗下专注于高性能铜合金材料销售与技术支持的企业，面向汽车电子、通信设备、工业控制与消费电子等行业，提供从材料选型、样品验证到量产导入的全流程服务。
				</p>
				<div class="two-col">
					<div class="col-text">
						<h3>事业内容</h3>
						<p>
							公司主营各类精密铜合金带材与相关制品的推广，涵盖连接器用弹性材料、引线框架材料、散热与电磁屏蔽场景用材等。我们与集团内制造基地及研发部门协同，可协助客户评估加工性、镀层兼容性与长期可靠性。
						</p>
						<h3>品质与合规</h3>
						<p>
							材料批次可追溯，并可按客户要求提供成分、机械性能及表面品质等方面的技术资料。我们重视环保与安全法规要求，在材料声明与有害物质管理方面配合客户审核需求。
						</p>
					</div>
					<div class="col-text">
						<h3>研发与技术支持</h3>
						<p>
							针对新产品开发阶段，我们可配合提供材料对比数据、成形与冲裁试验建议，并与客户共同优化合金牌号与规格设计，以兼顾导电性、强度与成本。
						</p>
						<h3>全球网络</h3>
						<p>
							DOWA 集团在亚洲多地设有制造与贸易据点。上海公司作为区域窗口，可协助客户联络集团内其它事业部，满足跨国项目中的材料统一规格与交付安排。
						</p>
					</div>
				</div>
			</div>
		</section>

		<section class="section brochure-strip">
			<div class="container">
				<h2 class="section-title">公司介绍资料</h2>
				<div class="brochure-masonry">
					<div
						v-for="(col, colIndex) in masonryColumns"
						:key="'masonry-col-' + colIndex"
						class="masonry-column"
					>
						<template v-for="item in col">
							<article
								v-if="item.type === 'text'"
								:key="item.key"
								class="brochure-text"
							>
								<h3 class="brochure-text-title">{{ item.title }}</h3>
								<p v-if="item.subtitle" class="brochure-text-sub">{{ item.subtitle }}</p>
								<p
									v-for="(para, pi) in item.paragraphs"
									:key="item.key + '-p-' + pi"
									class="brochure-text-p"
								>{{ para }}</p>
								<ul v-if="item.list && item.list.length" class="brochure-text-list">
									<li v-for="(li, liIdx) in item.list" :key="item.key + '-l-' + liIdx">{{ li }}</li>
								</ul>
							</article>
							<figure
								v-else
								:key="item.key"
								class="brochure-figure"
							>
								<img
									:src="item.url"
									:alt="item.title || '公司介绍配图'"
									@load="onBrochureImgLoad($event, item.url)"
									@error="onBrochureError($event)"
								/>
							</figure>
						</template>
					</div>
				</div>
			</div>
		</section>

		<section class="section intro-strip">
			<div class="container intro-grid">
				<div class="intro-card">
					<div class="intro-card-media">
						<img :src="imgSrc.feature1" alt="" @error="onImgError('feature1')" />
					</div>
					<h2>合金材料</h2>
					<p>铜合金、钛铜、铜镍硅、黄铜、纯铜等系列产品，满足精密冲压、蚀刻与电镀等后道工序对板型与表面质量的要求。</p>
				</div>
				<div class="intro-card">
					<div class="intro-card-media">
						<img :src="imgSrc.feature2" alt="" @error="onImgError('feature2')" />
					</div>
					<h2>多领域应用</h2>
					<p>面向连接器、继电器、功率模块散热与结构件等应用，协助客户在性能、可焊性与成本之间取得平衡。</p>
				</div>
				<div class="intro-card">
					<div class="intro-card-media">
						<img :src="imgSrc.feature3" alt="" @error="onImgError('feature3')" />
					</div>
					<h2>服务与交付</h2>
					<p>材料咨询、技术资料下载与各地联络窗口，缩短沟通链条，让样品与批量订单更可预期。</p>
				</div>
			</div>
		</section>

		<section class="section sectors">
			<div class="container">
				<h2 class="section-title">功能导航 · 产品分类</h2>
				<p class="section-desc">按合金体系进入产品列表</p>
				<div class="sector-grid">
					<router-link v-for="item in productLinks" :key="item.to" :to="item.to" class="sector-card">
						<span class="sector-name">{{ item.label }}</span>
						<span class="sector-arrow">→</span>
					</router-link>
				</div>
			</div>
		</section>

		<section class="mid-banner" :style="midBannerStyle">
			<div class="container mid-banner-inner">
				<h2>材料技术，驱动产品升级</h2>
				<p>从样品评估到量产导入，我们与您共同优化材料选型与工艺窗口。</p>
				<router-link class="btn btn-light" to="/contactUs">联系方式</router-link>
			</div>
		</section>

		<section class="section quick-links">
			<div class="container quick-grid">
				<router-link to="/questionnaire" class="quick-tile">
					<strong>材料咨询</strong>
					<span>提交需求与样品信息</span>
				</router-link>
				<router-link to="/profiledownload" class="quick-tile">
					<strong>资料下载</strong>
					<span>技术资料与手册</span>
				</router-link>
				<router-link to="/contactUs" class="quick-tile">
					<strong>联系我们</strong>
					<span>各地据点与电话</span>
				</router-link>
			</div>
		</section>

		<CopyrightBottom />
	</div>
</template>

<script>
import CopyrightBottom from '@/components/CopyrightBottom';
import { HOME_IMAGES } from '@/config/homeAssets';
import { buildBrochureItems, assignMasonryColumns } from '@/config/homeBrochureItems';

export default {
	name: 'Home',
	components: { CopyrightBottom },
	data() {
		const imgSrc = {};
		Object.keys(HOME_IMAGES).forEach((k) => {
			imgSrc[k] = HOME_IMAGES[k].local;
		});
		return {
			imgSrc,
			brochureItems: buildBrochureItems(),
			brochureDimensions: {},
			winWidth: typeof window !== 'undefined' ? window.innerWidth : 1200,
			productLinks: [
				{ label: '铜合金', to: '/productclass/1' },
				{ label: '钛铜', to: '/productclass/2' },
				{ label: '铜镍硅', to: '/productclass/3' },
				{ label: '黄铜', to: '/productclass/4' },
				{ label: '纯铜', to: '/productclass/5' },
			],
		};
	},
	computed: {
		heroBgStyle() {
			const u = this.imgSrc.hero || HOME_IMAGES.hero.fallback;
			return {
				backgroundImage:
					'linear-gradient(118deg, rgba(8, 56, 58, 0.82) 0%, rgba(19, 136, 142, 0.55) 55%, rgba(19, 136, 142, 0.35) 100%), url(' +
					u +
					')',
			};
		},
		midBannerStyle() {
			const u = this.imgSrc.banner2 || HOME_IMAGES.banner2.fallback;
			return {
				backgroundImage:
					'linear-gradient(90deg, rgba(19, 136, 142, 0.88), rgba(12, 90, 94, 0.75)), url(' + u + ')',
			};
		},
		masonryColumnCount() {
			if (this.winWidth >= 900) return 3;
			if (this.winWidth >= 640) return 2;
			return 1;
		},
		masonryColumns() {
			const count = this.masonryColumnCount;
			const gap = 20;
			const containerWidth = Math.min(this.winWidth - 32, 1100);
			const colWidth = count > 1 ? (containerWidth - gap * (count - 1)) / count : containerWidth;
			return assignMasonryColumns(
				this.brochureItems,
				count,
				colWidth,
				gap,
				this.brochureDimensions
			);
		},
	},
	methods: {
		scrollTo(id) {
			const el = document.getElementById(id);
			if (el) {
				el.scrollIntoView({ behavior: 'smooth', block: 'start' });
			}
		},
		onImgError(key) {
			const cfg = HOME_IMAGES[key];
			if (cfg && this.imgSrc[key] !== cfg.fallback) {
				this.$set(this.imgSrc, key, cfg.fallback);
			}
		},
		onBrochureImgLoad(e, url) {
			const img = e.target;
			if (!img.naturalWidth) return;
			const prev = this.brochureDimensions[url];
			if (prev && prev.w === img.naturalWidth && prev.h === img.naturalHeight) return;
			this.$set(this.brochureDimensions, url, {
				w: img.naturalWidth,
				h: img.naturalHeight,
			});
		},
		onBrochureError(e) {
			const u = HOME_IMAGES.hero.fallback;
			if (e.target.src !== u) {
				e.target.src = u;
			}
		},
		onWindowResize() {
			this.winWidth = window.innerWidth;
		},
		preloadBrochureDimensions() {
			this.brochureItems.forEach((item) => {
				if (item.type !== 'image') return;
				const url = item.url;
				const img = new Image();
				img.onload = () => {
					if (!img.naturalWidth) return;
					this.$set(this.brochureDimensions, url, {
						w: img.naturalWidth,
						h: img.naturalHeight,
					});
				};
				img.src = url;
			});
		},
	},
	mounted() {
		this.onWindowResize();
		window.addEventListener('resize', this.onWindowResize);
		this.preloadBrochureDimensions();
		['hero', 'banner2'].forEach((key) => {
			const cfg = HOME_IMAGES[key];
			if (!cfg) return;
			const probe = new Image();
			probe.onerror = () => {
				if (this.imgSrc[key] === cfg.local) {
					this.$set(this.imgSrc, key, cfg.fallback);
				}
			};
			probe.src = cfg.local;
		});
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onWindowResize);
	},
};
</script>

<style scoped>
.home-page {
	width: 100%;
	min-height: 100vh;
	background: #f5f9f9;
	padding-top: 50px;
	box-sizing: border-box;
}

.hero {
	min-height: 52vh;
	background-size: cover;
	background-position: center;
	display: flex;
	align-items: flex-end;
	padding: 48px 20px 56px;
	box-sizing: border-box;
}

.hero-inner {
	max-width: 1100px;
	margin: 0 auto;
	width: 100%;
	color: #fff;
	text-align: left;
}

.hero-tag {
	font-size: 13px;
	letter-spacing: 0.12em;
	text-transform: uppercase;
	opacity: 0.95;
	margin: 0 0 8px;
}

.hero-title {
	font-size: 24px;
	font-weight: 700;
	line-height: 1.25;
	margin: 0 0 12px;
	text-shadow: 0 2px 12px rgba(0, 0, 0, 0.25);
}

.hero-sub {
	font-size: 15px;
	line-height: 1.55;
	max-width: 40em;
	margin: 0 0 22px;
	opacity: 0.96;
}

.hero-actions {
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
}

.btn {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 10px 18px;
	border-radius: 6px;
	font-size: 14px;
	text-decoration: none;
	font-weight: 600;
	border: 2px solid transparent;
	transition: background 0.2s, color 0.2s, border-color 0.2s;
	cursor: pointer;
	box-sizing: border-box;
}

.btn-primary {
	background: #fff;
	color: #0d6b70;
	border-color: #fff;
}
.btn-primary:hover {
	background: #e8f7f7;
}

.btn-outline {
	background: rgba(255, 255, 255, 0.12);
	color: #fff;
	border-color: rgba(255, 255, 255, 0.65);
}
.btn-outline:hover {
	background: rgba(255, 255, 255, 0.22);
}

.section {
	padding: 40px 16px;
}

.container {
	max-width: 1100px;
	margin: 0 auto;
}

.company-intro {
	background: #fff;
	text-align: left;
}

.lead {
	font-size: 16px;
	line-height: 1.75;
	color: #3d5a5c;
	margin: 0 0 28px;
}

.two-col {
	display: grid;
	grid-template-columns: 1fr;
	gap: 28px;
}

.col-text h3 {
	margin: 0 0 10px;
	font-size: 17px;
	color: #13888e;
}
.col-text p {
	margin: 0 0 18px;
	font-size: 14px;
	line-height: 1.7;
	color: #3d5a5c;
}
.col-text p:last-child {
	margin-bottom: 0;
}

.brochure-strip {
	background: #f0fafb;
}

.brochure-strip .section-title {
	margin-bottom: 24px;
}

.brochure-masonry {
	display: flex;
	align-items: flex-start;
	gap: 20px;
}

.masonry-column {
	flex: 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
	gap: 20px;
}

.brochure-figure {
	margin: 0;
	background: #fff;
	border-radius: 10px;
	overflow: hidden;
	box-shadow: 0 8px 28px rgba(19, 136, 142, 0.1);
}

.brochure-figure img {
	width: 100%;
	height: auto;
	display: block;
}

.brochure-text {
	margin: 0;
	padding: 20px 22px;
	background: #fff;
	border-radius: 10px;
	border-left: 4px solid #13888e;
	box-shadow: 0 8px 28px rgba(19, 136, 142, 0.1);
	text-align: left;
}

.brochure-text-title {
	margin: 0 0 6px;
	font-size: 17px;
	font-weight: 700;
	color: #0d4d51;
	line-height: 1.35;
}

.brochure-text-sub {
	margin: 0 0 12px;
	font-size: 14px;
	font-weight: 600;
	color: #13888e;
	line-height: 1.4;
}

.brochure-text-p {
	margin: 0 0 10px;
	font-size: 14px;
	line-height: 1.7;
	color: #3d5a5c;
}
.brochure-text-p:last-of-type {
	margin-bottom: 0;
}

.brochure-text-list {
	margin: 10px 0 0;
	padding-left: 1.2em;
	color: #3d5a5c;
	font-size: 14px;
	line-height: 1.65;
}
.brochure-text-list li {
	margin-bottom: 4px;
}

.intro-grid {
	display: grid;
	grid-template-columns: 1fr;
	gap: 20px;
}

.intro-card {
	background: #fff;
	border-radius: 10px;
	padding: 20px;
	box-shadow: 0 8px 28px rgba(19, 136, 142, 0.08);
	text-align: left;
}

.intro-card-media {
	border-radius: 8px;
	overflow: hidden;
	margin-bottom: 14px;
	aspect-ratio: 16 / 10;
	background: #e8f2f2;
}
.intro-card-media img {
	width: 100%;
	height: 100%;
	object-fit: cover;
	display: block;
}

.intro-card h2 {
	margin: 0 0 8px;
	font-size: 17px;
	color: #13888e;
}
.intro-card p {
	margin: 0;
	font-size: 14px;
	line-height: 1.55;
	color: #3d5a5c;
}

.sectors {
	background: #fff;
}

.section-title {
	margin: 0 0 6px;
	font-size: 22px;
	color: #0d4d51;
	text-align: center;
}
.section-desc {
	margin: 0 0 24px;
	text-align: center;
	color: #5a7a7c;
	font-size: 14px;
}

.sector-grid {
	display: grid;
	grid-template-columns: 1fr;
	gap: 12px;
}

.sector-card {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 16px 18px;
	background: linear-gradient(135deg, #f0fafb, #fff);
	border: 1px solid rgba(19, 136, 142, 0.2);
	border-radius: 8px;
	text-decoration: none;
	color: #13888e;
	font-weight: 600;
	font-size: 15px;
	transition: transform 0.15s, box-shadow 0.15s;
}
.sector-card:hover {
	transform: translateY(-2px);
	box-shadow: 0 6px 20px rgba(19, 136, 142, 0.15);
}
.sector-arrow {
	opacity: 0.7;
	font-size: 18px;
}

.mid-banner {
	position: relative;
	background-size: cover;
	background-position: center;
	padding: 48px 16px;
	overflow: hidden;
}
.mid-banner-inner {
	position: relative;
	z-index: 1;
	color: #fff;
	text-align: center;
	max-width: 640px;
	margin: 0 auto;
}
.mid-banner-inner h2 {
	margin: 0 0 10px;
	font-size: 20px;
}
.mid-banner-inner p {
	margin: 0 0 18px;
	font-size: 14px;
	line-height: 1.6;
	opacity: 0.95;
}
.btn-light {
	background: #fff;
	color: #0d6b70;
	border: 2px solid #fff;
}
.btn-light:hover {
	background: #e8f7f7;
}

.quick-links {
	padding-bottom: 32px;
}
.quick-grid {
	display: grid;
	grid-template-columns: 1fr;
	gap: 12px;
}
.quick-tile {
	display: block;
	padding: 18px 20px;
	background: #fff;
	border-radius: 8px;
	text-decoration: none;
	color: #13888e;
	border: 1px solid rgba(19, 136, 142, 0.18);
	text-align: left;
	transition: box-shadow 0.15s;
}
.quick-tile:hover {
	box-shadow: 0 6px 18px rgba(19, 136, 142, 0.12);
}
.quick-tile strong {
	display: block;
	font-size: 16px;
	margin-bottom: 4px;
	color: #0d4d51;
}
.quick-tile span {
	font-size: 13px;
	color: #5a7a7c;
}

@media (min-width: 640px) {
	.hero-title {
		font-size: 30px;
	}
	.sector-grid {
		grid-template-columns: repeat(2, 1fr);
	}
	.quick-grid {
		grid-template-columns: repeat(3, 1fr);
	}
}

@media (min-width: 900px) {
	.hero {
		min-height: 58vh;
		padding: 64px 32px 72px;
		align-items: center;
	}
	.hero-title {
		font-size: 36px;
	}
	.hero-sub {
		font-size: 16px;
	}
	.two-col {
		grid-template-columns: 1fr 1fr;
		gap: 40px;
	}
	.intro-grid {
		grid-template-columns: repeat(3, 1fr);
		gap: 24px;
	}
	.sector-grid {
		grid-template-columns: repeat(3, 1fr);
	}
	.section {
		padding: 48px 24px;
	}
	.mid-banner-inner h2 {
		font-size: 24px;
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/home.vue